module.exports = "/images/scrollTop.png?48e8638c320a98b50175211521af12fd";